import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'

import Signup3Contractor from '../../../../../presentation/pages/contractors/amplify/signup3Contractors'

import { makeContractorRegister } from '../../../../usecases/contractorsRegister/remote-contracorsRegister-factory'

import { HelperViaCep } from '../../../../../presentation/helpers/helper-via-cep'
import { STATES } from '../../../../../presentation/helpers'
import { RoutesEnum } from '../../../../../presentation/enums'

const MakeSignup3Contractors = (): JSX.Element => {
  window.dataLayer.push({
    event: 'signupContractor3',
  })
  document.title = 'BuscarMédicos - Cadastro - Passo 3'

  const history = useHistory()

  const [errorMessage] = useState<string | null>('')

  const [cep, setCep] = useState('')

  const [address, setAddress] = useState({
    city: '',
    neighborhood: '',
    street: '',
    state: '',
    zipcode: '',
  })

  const handleCepSelect = (data: any) => {
    const numericCep = data.replace(/\D/g, '')
    setCep(numericCep)
  }

  useEffect(() => {
    const fetchAddress = async () => {
      if (cep.length >= 8) {
        const response = await HelperViaCep.getAdressByCep(cep)
        setAddress(response as any)
      }
      if (cep.length < 8) {
        setAddress({
          city: '',
          neighborhood: '',
          street: '',
          state: '',
          zipcode: cep,
        })
      }
    }
    fetchAddress()
  }, [cep])

  const dataForm = [
    {
      items: [
        {
          component: 'InputMask',
          mask: 'CEP',
          name: 'zipcode',
          label: 'Informe o CEP',
          title: 'Informe o CEP',
          value: address.zipcode,
          type: 'tel',
          required: true,
          placeholder: 'Digite aqui',
          validations: 'inputRequired',
          onChange: handleCepSelect,
        },
        {
          name: 'street',
          component: 'Input',
          value: address.street,
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Rua',
          label: 'Rua',
          required: true,
          validations: 'inputRequired',
          style: { marginBottom: '15px' },
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'number',
              component: 'InputMask',
              mask: 'ONLY_NUMBERS',
              value: '',
              placeholder: 'Digite aqui',
              type: 'tel',
              title: 'Número',
              label: 'Número',
            },
            {
              name: 'neighborhood',
              component: 'Input',
              value: address.neighborhood,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Bairro',
              label: 'Bairro',
              required: true,
              validations: 'inputRequired',
            },
          ],
        },
        {
          component: 'InputGroup',
          style: { display: 'grid', gridTemplateColumns: '1fr 1fr' },
          inputs: [
            {
              name: 'city',
              component: 'Input',
              value: address.city,
              placeholder: 'Digite aqui',
              type: 'text',
              title: 'Cidade',
              label: 'Cidade',
              required: true,
              validations: 'inputRequired',
            },
            {
              component: 'Select',
              title: 'Estado',
              label: 'Estado',
              value: address.state,
              name: 'state',
              required: true,
              placeholder: 'Selecione seu Estado',
              options: STATES.map((option) => ({
                label: option.name,
                value: option.uf,
              })),
            },
          ],
        },
        {
          name: 'complements',
          component: 'Input',
          value: '',
          placeholder: 'Digite aqui',
          type: 'text',
          title: 'Complemento',
          label: 'Complemento',
          style: { marginBottom: '15px' },
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Prosseguir',
          submittingText: 'Carregando...',
          color: true,
        },
      ],
    },
  ]

  const onSubmit = async (values: any): Promise<void> => {
    const userEmail = localStorage.getItem('userEmail')

    try {
      const requestData = {
        email: userEmail,
        address: {
          zipcode: values.zipcode,
          street: values.street,
          number: values.number,
          neighborhood: values.neighborhood,
          city: values.city,
          state: values.state,
          complement: values.complements,
        },
      }

      await makeContractorRegister('step-three').post(requestData)
      history.push(RoutesEnum.TERMS_CONTRACTOR)
    } catch (error) {
      console.error('Erro ao enviar formulário:', error)
    }
  }

  return (
    <Signup3Contractor
      dataForm={dataForm}
      onSubmit={onSubmit}
      errorMessage={errorMessage}
    />
  )
}

export default MakeSignup3Contractors
